<template>
  <button @click="throwError">Click to throw error</button>
</template>

<script setup lang="ts">
const throwError = () => {
  throw new Error("Testing a manual Sentry error");
};
</script>
